import { useCallback } from 'react'

import { selectPerpsProvider } from 'state/futures/common/selectors'
import { useFetchReferralData } from 'state/futures/hooks'
import { useAppSelector, useFetchAction } from 'state/hooks'
import { selectWallet } from 'state/wallet/selectors'

import { fetchLeaderboard } from './actions'
import { selectValidSearchTerm } from './selectors'

export const useLeaderboardData = () => {
	const searchTerm = useAppSelector(selectValidSearchTerm)
	const wallet = useAppSelector(selectWallet)
	const perpsProvider = useAppSelector(selectPerpsProvider)

	useFetchReferralData()

	const fetchLeaderboardAction = useCallback(
		() => fetchLeaderboard([perpsProvider]),
		[perpsProvider]
	)

	useFetchAction(fetchLeaderboardAction, {
		dependencies: [searchTerm, wallet, perpsProvider],
	})
}
